// 新建流程
/* eslint-disable complexity */
/* eslint-disable max-depth */
import React, {
  ReactNode,
  memo,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import { connect } from "dvajs";
import {
  Button,
  Input,
  Select,
  Checkbox,
  // Radio,
  message,
  Switch,
  Drawer,
  Modal,
  Collapse,
  Tooltip,
  Empty
} from "antd";
import CalendarDatePicker from "@/components/Calendars/BaseComponents/DatePicker";
import ScheduleTypeSelect, { scheduleTypeList } from "./../ScheduleTypeSelect";
import "./index.less";
import dayjs, { Dayjs } from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { withTranslation, WithTranslation } from "react-i18next";
import { analysisLog } from "@/utils/logAnalytics";

import {
  addSchedule,
  modifySchedule,
  RemindMode,
  User,
  ModifyType,
  CalendarInfo,
  Schedule,
  Agent,
  IMeetingModal,
  shareScheduleAttachment,
  getScheduleListByDateAndUsersAndGroupByUser
} from "@/api/calendar";
import log from "@/utils/logger";
import bus from "@/utils/bus";
import config, { ConfigEnum } from "@/config/config";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { debounce, throttle } from "lodash";
import { ChatMessageBody, ChatMessageType, Session } from "@/types/chat";
import DeeplinkEvent, { DeeplinkPathEnum } from "@/components/DeeplinkHandler/DeeplinkEvent";
import { generateMessageId } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import IconFont from "@/components/icon";
import { openUserSelectionModal } from "@/utils/modals";
import LiveLimit from "./LiveLimit";
import { findIndexExecutorInTask } from "@/components/Work/utils";
import ChatState from "@/types/chat/State";
import { decorateQuickCreateTaskResource } from "@/components/Work/newUtils";
import lodashCompact from "lodash/compact";
import BaseTextArea from "../components/BaseTextArea";
import cloneDeep from "lodash/cloneDeep";
import ScrollView from "@/baseComponents/ScrollView";
import { MeetingPlatform } from "@/types/common";
import "@/components/Calendars/Calendars.less";
import CopyFrame from "@/components/CopyFrame";
import { isFocusEnv, FocusSDK as focusSDK } from "@/utils";
import colors from "@/components/styles/colors";
import { GlobalPermissionsFun } from "@/utils/globalDataInitFun";
import RepatSelect, { judgeRepeat } from "./RepatSelect";
import { RemindSelect } from "./RemindSelect";
import AttachmentItem from "@/components/AttachmentComp/attachmentItem";
import { TaskResourceBizType, TaskResourcePermissionType } from "@/types/work";
import { nanoid } from "nanoid";
import { ContactShowType } from "@jd/focus-desktop-comps/lib/es/UserSelection/types";
import { AppTrialStatus, getAppApplyStatus } from "@/components/ThirdApp/utils";
import { DragState, DragType } from "../Enums";
import { BusyIdleViewHeader, ScheduleByDateAndUsersProps } from "./BusyIdleHeader";
import noDataPictureTransparent from "@/assets/img/no-content1.png";
import { tagsNode } from "@/components/Joyspace/contextModal/AddMembers/baseComponents/Item";
import { changeEgovUrl } from "@/utils/tools";
import { BusinessForm } from "@/utils/chat/message";
import {
  BusyIdleView,
  SchedulePositionInfoProps,
  calculateTimeByPosition,
  getTimeWithFixedMinute,
  timeInterval
} from "./BusyIdleViewDraw/BusyIdleView";
import TypeSelect from "@/components/Work/BaseComponents/TypeSelect";
import { Avatar } from "@/baseComponents/Avatar";
import UserStatusListPopover from "@/baseComponents/UserStatusListPopover";
import UserListMore from "@/baseComponents/UserListMore";

dayjs.extend(isSameOrBefore);
dayjs.extend(isoWeek);
const { Option } = Select;

function getStartTimeList(d?: dayjs.Dayjs) {
  let n = d || dayjs();
  let today = n.startOf("date");
  let hourList = Array.from(new Array(144).keys());
  let data = hourList.map((item, index) => {
    let time = today.add(index * timeInterval, "minute");
    return {
      value: time,
      title: time.format("HH:mm")
    };
  });
  return data;
}

export enum CreateModalFrom {
  // Card = 0,
  // Calendar = 1,
  Unknown = -1, // 来源未知
  ButtonCreate = 0, // 按钮新建
  DragCreate = 1, // 拖拽快速创建
  Workbench = 2 // 工作台新建
}

interface IScheduleCopy {
  title: string;
  resources: any[];
  beginTime: any;
  endTime: any;
  repeatEndTime: any;
  meetingInfo: IMeetingModal | null; // 视频会议信息
  syncAppointMeeting: boolean; // 是否同步创建会议
  calendarId: string; // 日历
  isAllDay: boolean; // 是否全天
  repeat: number; // 重复设置
  address: string; // 地点
  calendarColor: string; // 日历颜色
  description: string; // 描述信息
  remark: string; // 我的备注
  remindList: RemindMode[]; // 提醒列表
  isRemind: boolean;
  customizeRemind: any[]; // 自定义提醒列表
  ownerUser: any[]; // 创建人
  participant: any[]; // 参与人
}

export enum ScheduleCopyKey {
  title = "title",
  resources = "resources",
  beginTime = "beginTime",
  endTime = "endTime",
  repeatEndTime = "repeatEndTime",
  meetingInfo = "meetingInfo",
  syncAppointMeeting = "syncAppointMeeting",
  calendarId = "calendarId",
  isAllDay = "isAllDay",
  repeat = "repeat",
  address = "address",
  calendarColor = "calendarColor",
  description = "description",
  remark = "remark",
  remindList = "remindList",
  isRemind = "isRemind",
  customizeRemind = "customizeRemind",
  ownerUser = "ownerUser",
  participant = "participant"
}
interface OwnState {
  visible: boolean;
  title: string;
  beginDate: Dayjs;
  endDate: Dayjs;
  oldBeginTime: Dayjs;
  beginTime: Dayjs;
  endTime: Dayjs;
  repeatEndTime: any;
  // 是否全天
  isAllDay: boolean;
  // 重复设置
  repeat: number;
  // 提醒
  remind: string;
  // 地点
  address: string;
  // 日历
  calendarId: string;
  // 日历颜色
  calendarColor: string;
  // 描述信息
  description: string;
  // 我的备注
  remark: string;
  // 是否显示快速创建弹窗
  quickCreateFlag: boolean | undefined;
  createFrom: number | undefined;
  participant: any[]; // 参与人
  ownerUser: any[]; // 创建人
  endTimeList: any[]; // 结束时间渲染列表，要根据beginTime获取
  resources: any[];
  remindList: RemindMode[]; // 提醒列表
  isRemind: boolean; // 提醒开关
  customizeRemind: any[]; // 自定义提醒list
  syncAppointMeeting: boolean; // 是否同步创建会议
  meetingPlatform: MeetingPlatform | string;
  meetingPlatformName: string;
  isLive: boolean;
  meetingCustom: any; // 会议自定义参数
  meetingInfo: IMeetingModal | null; // 视频会议信息
  noAPModalVisible: boolean; // 是否显示无代理权限提示
  createClick: boolean; // 防重点击
  meetingInfoChanged: boolean; // 用于标记会议相关信息是否被修改了
  scheduleCopy: IScheduleCopy | null; // 用于备份日程编辑前的初始值
  isCrossPlatform: number; // 是否是跨平台 0否 1是
  selTime: Dayjs; // 日程忙闲选中的时间
  schedulesByUserList: ScheduleByDateAndUsersProps[]; // 忙闲人员日程
}

interface conferencePlatformsProp {
  applicationId: string;
  platformType: string;
  platformName: string;
}

export enum ScheduleMode {
  Create = 1,
  Modify,
  CopyCreate
}

export enum CreateScheduleSourceEnum {
  self = 1, // 自建
  emial = 2, // 邮件
  timeline = 3, // 咚咚
  project = 4 // 专班
}

interface IProps {
  visible: boolean;
  userInfo: any;
  userData: any;
  calendarList: any;
  changeCreateModalVisible: (visible: boolean) => void;
  setSelectedCalendarList: (data: any) => void;
  onSave?: () => void;
  quickCreate?: boolean;
  createFrom?: number;
  beginTime: Dayjs;
  endTime: Dayjs;
  createModalFrom?: CreateModalFrom;
  myCalendar: CalendarInfo;
  getScheduleListByTime: (data: {
    user?: User;
    calendarId?: string;
    beginTime: Dayjs;
    endTime: Dayjs;
  }) => void;
  selectedCalendarList: any[];
  selectedTime: any;
  mode?: ScheduleMode;
  modifyScheduleContent?: any;
  openCreateModal: (data: any) => void;
  getCalendarList: Function;
  sence?: string; // 场景，预约会议：appointment | 创建日程：create
  frozenCalendarId: string;
  selectedSession: Session;
  isMessageModule: boolean;
  getConferencePlatforms: Function;
  conferencePlatforms: any[]; // 会议类型列表
  meetingPlatform?: string;
  isLive?: boolean;
  title?: string;
  messageResource?: any[];
  repeatEndTime?: any;
  isCrossPlatform?: number; // 是否是跨平台 0否 1是
  defaultAppointment?: boolean;
  defaultParticipant?: any[];
  isCopyCreate?: boolean;
}
type Props = Readonly<WithTranslation & IProps & ChatState>;

const DEFAULT_MEETING_INFO: IMeetingModal = {
  type: "meeting",
  meetingType: 0,
  title: "",
  meetingId: "",
  meetingUuid: "",
  password: "",
  meetingPlatform: "",
  meetingPlatformName: "",
  liveInfo: { liveUrl: "", liveId: "", password: "", maxPeopleCount: null }
};
const DEFAULT_MAX_PEOPLE = 1000;

export function CreateSchedule(props: Props) {
  const {
    imService,
    permissions,
    setPermissions,
    globalDataInitFlag,
    setGlobalDataInitFlag
  } = useContext<GlobalContextConfig>(GlobalContext);
  const themeRef: any = useRef(null);
  const meetingPasswordRef: any = useRef(null);
  const scrollRef: any = useRef(null);

  const busyIdleTimeBlock: any = useRef(null);
  const {
    quickCreate,
    createFrom,
    beginTime,
    endTime,
    visible,
    userData,
    conferencePlatforms,
    isCopyCreate
  } = props;
  const [state, setState] = useState<OwnState>({
    visible,
    title: "",
    beginDate: beginTime || dayjs(),
    endDate: endTime || dayjs(),
    oldBeginTime: beginTime || dayjs(),
    beginTime: beginTime || dayjs(),
    endTime: endTime || dayjs().add(30, "minute"),
    repeatEndTime: null,
    isAllDay: false,
    repeat: 0,
    remind: RemindMode.Start0 + "," + RemindMode.Start15, // 默认前5分钟提醒
    address: "",
    calendarId: "",
    calendarColor: "",
    description: "",
    remark: "",
    quickCreateFlag: quickCreate,
    createFrom: createFrom, // 创建来源
    participant: [],
    meetingCustom: {
      room: null,
      terminalId: []
    },
    // TODO: 创建人
    ownerUser: [
      {
        userId: userData.userId,
        teamId: userData.teamUserInfo?.teamId,
        app: userData?.ddAppId,
        headImg: userData.teamUserInfo?.headImg || "",
        realName: userData.teamUserInfo?.realName || userData.account
      }
    ],
    endTimeList: [],
    resources: [],
    remindList: [RemindMode.Start0, RemindMode.Start15],
    isRemind: true, // 默认提醒打开
    customizeRemind: [], // 默认自定义提醒是空
    syncAppointMeeting: false,
    isLive: false,
    meetingPlatform: conferencePlatforms[0]?.platformType || "",
    meetingPlatformName: conferencePlatforms[0]?.platformName || "",
    meetingInfo: null,
    noAPModalVisible: false,
    createClick: false,
    meetingInfoChanged: false,
    scheduleCopy: null,
    isCrossPlatform: 0,
    selTime: beginTime || dayjs(),
    schedulesByUserList: []
  });
  const [busyIdleUsers, setBusyIdleUsers] = useState<any[]>([]);
  const [visibleBusyIdleUsersModal, setVisibleBusyIdleUsersModal] = useState(false);
  const [busyIdleParticipants, setBusyIdleParticipants] = useState<any[]>([]);
  const [busyIdleSearchValue, setBusyIdleSearchValue] = useState<string>("");
  const schedulePositionInfo: any = useRef([]);
  const busyIdleDivEl: any = useRef(null);
  const scheduleViewDrawRef = useRef(null);
  const [busyIdleViewWidth, setBusyIdleViewWidth] = useState(0);

  const handlechangeMeetingPass = (e: any) => {
    const value = e.target.value?.replace(/\s+/g, "");
    if (Number.isNaN(Number(value))) {
      return;
    }
    if (value.length > 6) {
      return;
    }
    setState({
      ...state,
      meetingInfo: {
        ...(state.meetingInfo as IMeetingModal),
        password: value
      },
      meetingInfoChanged: true
    });
  };
  const handleLimitChange = (e: any) => {
    setState({
      ...state,
      meetingInfo: {
        ...(state.meetingInfo as IMeetingModal),
        liveInfo: {
          ...(state.meetingInfo?.liveInfo as any),
          maxPeopleCount: e
        }
      }
    });
  };
  const isScheduleEdited = () => {
    const { scheduleCopy } = state;
    let editedFlag = false;
    if (scheduleCopy) {
      const keys: ScheduleCopyKey[] = Object.keys(scheduleCopy) as ScheduleCopyKey[];
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < keys.length; i++) {
        if (editedFlag) break;
        // console.log(i + ':', keys[i]);
        switch (keys[i]) {
          case "beginTime":
          case "endTime": {
            if (
              !(
                scheduleCopy[keys[i]] &&
                state[keys[i]] &&
                scheduleCopy[keys[i]].valueOf() === state[keys[i]].valueOf()
              )
            ) {
              editedFlag = true;
            }
            break;
          }
          case "resources": {
            if (scheduleCopy[keys[i]].length !== state[keys[i]].length) {
              editedFlag = true;
            } else {
              let sameFlag = true;
              // eslint-disable-next-line @typescript-eslint/prefer-for-of
              for (let j = 0; j < scheduleCopy[keys[i]].length; j++) {
                let fileId = scheduleCopy[keys[i]][j].fileId;
                let exsitFlag = false;
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let k = 0; k < state[keys[i]].length; k++) {
                  if (state[keys[i]][k].fileId === fileId) {
                    exsitFlag = true;
                  }
                }
                if (!exsitFlag) {
                  sameFlag = false;
                  break;
                }
              }
              if (!sameFlag) editedFlag = true;
            }
            break;
          }
          case "customizeRemind":
          case "remindList": {
            if (scheduleCopy[keys[i]].length !== state[keys[i]].length) {
              editedFlag = true;
            } else {
              // eslint-disable-next-line @typescript-eslint/prefer-for-of
              for (let j = 0; j < scheduleCopy[keys[i]].length; j++) {
                if (state[keys[i]].indexOf(scheduleCopy[keys[i]][j]) <= -1) {
                  editedFlag = true;
                  break;
                }
              }
            }
            break;
          }
          case "ownerUser":
          case "participant": {
            if (scheduleCopy[keys[i]].length !== state[keys[i]].length) {
              editedFlag = true;
            } else {
              let sameFlag = true;
              // eslint-disable-next-line @typescript-eslint/prefer-for-of
              for (let j = 0; j < scheduleCopy[keys[i]].length; j++) {
                let userId = scheduleCopy[keys[i]][j].userId;
                let exsitFlag = false;
                // eslint-disable-next-line @typescript-eslint/prefer-for-of
                for (let k = 0; k < state[keys[i]].length; k++) {
                  if (state[keys[i]][k].userId === userId) {
                    exsitFlag = true;
                  }
                }
                if (!exsitFlag) {
                  sameFlag = false;
                  break;
                }
              }
              if (!sameFlag) editedFlag = true;
            }
            break;
          }
          default: {
            if (scheduleCopy[keys[i]] !== state[keys[i]]) {
              editedFlag = true;
            }
            break;
          }
        }
      }
    }
    return editedFlag;
  };
  const closeHandle = (isDone?: boolean) => {
    const { userInfo, modifyScheduleContent, mode, userData } = props;
    if (isScheduleEdited() && !isDone) {
      const { t } = props;
      const a = Modal.confirm({
        transitionName: "notransition",
        maskTransitionName: "notransition",
        maskStyle: { opacity: "0" },
        content:
          mode === ScheduleMode.Modify && modifyScheduleContent
            ? "退出编辑后将无法保存当前的更改，是否确认退出？"
            : "退出后将无法保存当前的内容，是否确认退出？",
        okText: t("confirm"),
        cancelText: t("cancel"),
        onOk() {
          bus.emit("close-modal-with-cancle-attachment-upload");
          props.openCreateModal({
            content: null,
            visible: false
          });
          props.changeCreateModalVisible(false);
          // 数据reset
          // setState({
          //   ...state,
          //   syncAppointMeeting: false
          // });
        }
      });
    } else {
      props.openCreateModal({
        content: null,
        visible: false
      });
      props.changeCreateModalVisible(false);
      // 数据reset
      // setState({
      //   ...state,
      //   syncAppointMeeting: false
      // });
      // bus.emit('Calendars:Attachment', true);
    }
  };

  const titleChangeHandle = (e: any) => {
    let title = e.target.value;
    setState({
      ...state,
      meetingInfoChanged: true,
      title
    });
  };
  const addressChangeHandle = (e: any) => {
    setState({
      ...state,
      address: e.target.value
    });
  };

  const descriptionChangeHandle = (e: any) => {
    let value = e.target.value;
    setState({
      ...state,
      description: value
    });
  };

  const remarkChangeHandle = (e: any) => {
    let value = e.target.value;
    setState({
      ...state,
      remark: value
    });
  };

  const handleTimeChange = async (
    time: Dayjs | null,
    start = true,
    schedulesByUserList: ScheduleByDateAndUsersProps[],
    isAllDay?: boolean
    // eslint-disable-next-line max-params
  ) => {
    const unix = time ? time : null;
    const { t } = props;
    if (start) {
      if (!unix || unix === state.beginTime) {
        return;
      }
      const changeObj: any = {
        schedulesByUserList,
        meetingInfoChanged: true,
        beginTime: unix,
        selTime: unix
      };
      if (
        !state.endTime ||
        (!!state.endTime && !!unix && unix?.add(30, "minute").isAfter(state.endTime))
      ) {
        changeObj.endTime = unix?.add(30, "minute") || state.endTime;
      }
      const eTime = changeObj.endTime || state.endTime;
      const minutespan = isAllDay
        ? dayjs(eTime?.format("YYYY-MM-DD 23:59")).diff(
            dayjs(changeObj.beginTime?.format("YYYY-MM-DD 00:00")),
            "minute"
          )
        : changeObj.beginTime && eTime.diff(changeObj.beginTime, "minute");
      const isDisabled = judgeRepeat(minutespan, state.repeat);
      // console.log("isDisabled-->", isDisabled, minutespan, state.repeat);
      if (isDisabled) {
        changeObj.repeat = 0;
        changeObj.repeatEndTime = null;
        message.warn("跨天时间间隔不能大于重复时间间隔");
      }
      setState({
        ...state,
        ...changeObj
      });
      return;
    }
    if (!unix || unix === state.endTime) {
      return;
    }
    if (state.beginTime && time) {
      if (!isAllDay) {
        if (state.beginTime.add(30, "minute").isAfter(time, "minute")) {
          return message.warn(t("deadline is at least 30 minutes later than the start time"));
        }
      } else {
        if (state.beginTime.isAfter(time)) {
          return message.warn(t("The deadline must not be earlier than the start time"));
        }
      }
    }
    const changeObj: any = {
      schedulesByUserList,
      meetingInfoChanged: true,
      endTime: unix
    };
    const minutespan = isAllDay
      ? dayjs(changeObj.endTime?.format("YYYY-MM-DD 23:59")).diff(
          dayjs(state.beginTime?.format("YYYY-MM-DD 00:00")),
          "minute"
        )
      : state.beginTime && changeObj.endTime.diff(state.beginTime, "minute");
    const isDisabled = judgeRepeat(minutespan, state.repeat);
    // console.log("isDisabled-->", isDisabled, minutespan, state.repeat);
    if (isDisabled) {
      changeObj.repeat = 0;
      changeObj.repeatEndTime = null;
      message.warn("跨天时间间隔不能大于重复时间间隔");
    }
    setState({
      ...state,
      ...changeObj
    });
    return;
  };

  const handleRepeatTimeChange = async (time: Dayjs | null) => {
    const unix = time ? time : null;
    // const { t } = props;
    if (unix) {
      if (dayjs(unix).isBefore(dayjs(state.beginTime), "date")) {
        return message.warn("重复截止日期不能早于日程开始日期");
      }
    }
    setState({
      ...state,
      repeatEndTime: unix
    });
  };

  const getScheduleColor = () => {
    // 1.改变日历时，后面日程的颜色跟随变化(取日历颜色)，
    // 如果主动选择了日程颜色(即日程颜色与日历颜色不一样时，接口入参正常传)，
    // 如果选择的日程颜色与日历颜色一样时，接口入参不传日程颜色
    const { calendarColor } = state;
    // 现在日历没有颜色概念，当颜色为空时，设置默认颜色
    return calendarColor || scheduleTypeList[2].color;
  };

  // 是否添加提醒
  const onSwitchChange = (checked: boolean) => {
    setState({
      ...state,
      isRemind: checked
    });
  };

  // 添加自定义提醒
  const addCustomRemind = () => {
    // 默认时间 就近15分钟
    let customTime = getTimeWithFixedMinute(dayjs());
    setState({
      ...state,
      customizeRemind: [
        ...state.customizeRemind,
        dayjs(customTime.format("YYYY-MM-DD HH:mm")).valueOf()
      ]
    });
  };
  // 删除自定义提醒时间
  const deleteCustomRemind = (index: number) => {
    const customReminds = [
      ...state.customizeRemind.slice(0, index),
      ...state.customizeRemind.slice(index + 1)
    ];
    setState({
      ...state,
      customizeRemind: customReminds
    });
  };
  // 设置自定义提醒时间
  const handleCustomRemindChange = (time: Dayjs | null, index: number) => {
    if (!time) return;
    console.log("", time.valueOf(), time.second(0), time.second(0).valueOf());
    setState({
      ...state,
      customizeRemind: [
        ...state.customizeRemind.slice(0, index),
        time.valueOf(),
        ...state.customizeRemind.slice(index + 1)
      ]
    });
  };

  const checkMeetingTrialPermissions = async (meetingInfo: IMeetingModal | null) => {
    // 可能存在有会议类型但并没有从conferencePlatforms中找到对应的applicationId
    const applicationId = props.conferencePlatforms.find(
      (item) => item.platformType === meetingInfo?.meetingPlatform
    )?.applicationId;
    if (applicationId) {
      const appApplyStatus = await getAppApplyStatus(applicationId, true);
      if (appApplyStatus !== AppTrialStatus.NORMAL) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  };

  const handleAddSchedule = async (isCreateSession?: boolean) => {
    setState({
      ...state,
      createClick: true
    });
    try {
      const { modifyScheduleContent, mode, userData } = props;
      // const { teamUserInfo, userId } = userData;
      const { syncAppointMeeting, meetingInfo } = state;
      const { myCalendar, t } = props;
      if (!state.title.trim()) {
        // title 不能为空
        throw new Error(t("schedule title not empty"));
      }
      // 注释掉参与人不能为空限制20210330
      // if (!state.participant.length) {
      //     message.warn({
      //         content: t('participant not empty'),
      //     });
      //     return;
      // }

      let beginTime;
      let endTime;
      if (state.beginTime && state.endTime) {
        if (state.isAllDay) {
          beginTime = dayjs(state.beginTime.format("YYYY-MM-DD 00:00")).valueOf();
          endTime = dayjs(state.endTime?.format("YYYY-MM-DD 23:59")).valueOf();
        } else {
          beginTime = dayjs(state.beginTime.format("YYYY-MM-DD HH:mm")).valueOf();
          endTime = dayjs(state.endTime.format("YYYY-MM-DD HH:mm")).valueOf();
        }
      } else {
        setState({
          ...state,
          createClick: false
        });
        message.error("请填写日程起止时间。");
        return;
      }
      let repeatEndTime = null;
      if (state.repeatEndTime) {
        repeatEndTime = dayjs(`${dayjs(state.repeatEndTime).format("YYYY-MM-DD 23:59")}`).valueOf();
      }

      // 判断参与人中是否存在跨平台人员
      const hasCrossPersonnel = state.participant.find((p) => p.userType === "5");
      // 创建或编辑重复日程与添加跨平台人员互斥
      if (state.repeat && (state.isCrossPlatform || hasCrossPersonnel)) {
        setState({
          ...state,
          createClick: false
        });
        return message.error(t("not support cross platform user participation"));
      }
      // 判断日程中是否存在云文档
      const hasJoyspace =
        state.resources.findIndex((item) => item.fileType?.startsWith("joyspace")) > -1;
      // 判断日程中是否存在记录纪要
      let hasMeetingMinutes = false;
      if (
        mode === ScheduleMode.Modify &&
        modifyScheduleContent &&
        modifyScheduleContent.meetingMinutes?.length > 0
      ) {
        hasMeetingMinutes = true;
      }
      // 添加云文档附件与添加跨平台人员互斥
      if ((hasJoyspace || hasMeetingMinutes) && (state.isCrossPlatform || hasCrossPersonnel)) {
        setState({
          ...state,
          createClick: false
        });
        return message.error(t("not support cross platform user use joyspace"));
      }

      // 提醒
      let remind =
        !state.remindList.length || !state.isRemind
          ? RemindMode.No
          : state.remindList.filter((item) => item !== RemindMode.No).join(",");
      let customizeRemindList = state.customizeRemind;
      for (let i = 0; i < customizeRemindList.sort().length - 1; i++) {
        let cur = Number(customizeRemindList[i]);
        let next = Number(customizeRemindList[i + 1]);
        if (cur && next && dayjs(cur).isSame(dayjs(next), "minute")) {
          customizeRemindList.splice(i, 1);
          i--;
        }
      }
      const scheduleData: any = {
        title: state.title.trim(),
        beginTime: beginTime,
        endTime: endTime,
        user: {
          teamId: userData?.team?.teamId,
          userId: userData?.userId
        },
        remind: remind || RemindMode.No,
        customizeRemind: state.isRemind ? customizeRemindList.join(",") : "",
        color: getScheduleColor() || null,
        repeat: state.repeat,
        repeatBeginTime: beginTime,
        repeatEndTime: repeatEndTime,
        meetingEnable: !!state.syncAppointMeeting,
        description: state.description,
        remark: state.remark,
        address: state.address,
        isAlldate: Number(state.isAllDay),
        groupId: "",
        calendarId: state.calendarId ? state.calendarId : myCalendar.calendarId,
        participant: state.participant,
        // TODO: 创建人 ownerUser
        content: "",
        resources: state.resources,
        ddAppId: userData.teamUserInfo.ddAppId
      };
      let newParticipant = state.participant.map((item: any) => {
        return { user: { ...item } };
      });
      scheduleData.participant = newParticipant;

      if (syncAppointMeeting) {
        // 不允许重复日程创建信创会议
        if (state.repeat !== 0 && state.meetingInfo?.meetingPlatform === "HW") {
          setState({
            ...state,
            createClick: false
          });
          return message.error(t("not allowed to add meeting repeated schedule"));
        }
        if (meetingInfo?.password && meetingInfo?.password?.length !== 6) {
          setState({
            ...state,
            createClick: false
          });
          return message.error(t("meetingPassLabel"));
        }
        // 在线会议不再判断是否是当前之前创建
        if (dayjs(scheduleData.beginTime).isSameOrBefore(dayjs())) {
          setState({
            ...state,
            createClick: false
          });
          return message.error(t("do not all appoint before"));
        }
      }
      if (mode === ScheduleMode.Modify && modifyScheduleContent) {
        // 修改
        let modifyType = ModifyType.Update;
        scheduleData.meetingMinutes = modifyScheduleContent.meetingMinutes;
        scheduleData.scheduleId = modifyScheduleContent.scheduleId;
        scheduleData.calendarType = modifyScheduleContent.calendarType;
        scheduleData.calendarId = modifyScheduleContent.calendarId;
        // TODO:这里可能需要对历史颜色做处理，看产品需求
        scheduleData.color = state.calendarColor || modifyScheduleContent.color;
        scheduleData.beforeBeginTime = modifyScheduleContent.scheduleBeginTime.valueOf();
        scheduleData.beforeEndTime = modifyScheduleContent.scheduleEndTime.valueOf();

        scheduleData.user = modifyScheduleContent.user;
        scheduleData.agent = modifyScheduleContent.agent;
        scheduleData.remarkId = modifyScheduleContent.remarkId;
        if (!modifyScheduleContent.modifyType) {
          // 变更方式 1. 重复-只更新单条 2. 重复-从当前时间更新 3. 更新（不重复的更新，由不重复到重复的更新） 4. 仅支持时间更新
          modifyType = ModifyType.Update;
        } else {
          modifyType = modifyScheduleContent.modifyType;
        }
        // 参与者信息修改
        let participant = newParticipant.map((item: any) => {
          return { resStatus: 0, ...item };
        });
        scheduleData.participant = participant;
        // TODO: 创建人修改ownerUser
        scheduleData.modifyType = modifyType;
        if (syncAppointMeeting) {
          // 如果不是会议直播并且会议的类型或密码发生变化，则重新校验会议权限，其余标题，时间等发生变化不算会议信息变化
          if (
            !state.isLive &&
            (meetingInfo?.meetingPlatform !== state.scheduleCopy?.meetingInfo?.meetingPlatform ||
              meetingInfo?.password !== state.scheduleCopy?.meetingInfo?.password)
          ) {
            const checkTP = await checkMeetingTrialPermissions(meetingInfo);
            if (!checkTP) {
              setState({
                ...state,
                createClick: false
              });
              return message.error(
                `您暂无${meetingInfo?.meetingPlatformName}的创建权限，请开通${meetingInfo?.meetingPlatformName}创建权限后，选择该会议。您可创建其他类型视频会议日程。`
              );
            }
          }
          meetingInfo && (meetingInfo.title = scheduleData.title);
          let originDescription = scheduleData.description;
          scheduleData.description =
            originDescription + `<p style="display:none;">${JSON.stringify(meetingInfo)}</p>`;
          // 编辑场景如果有会议信息且会议信息发生变化 进行会议权限校验

          focusSDK.printLog(
            "modifySchedule description",
            `${JSON.stringify(meetingInfo)} ${scheduleData.description}`
          );
        }
        const [data, err]: any = await modifySchedule(scheduleData);
        if (err) {
          console.error(err);
          throw new Error(err);
        }
        // 触发一个事件 告知群组是否需要更新日程详情显示数据
        bus.emit("chat:group:refreshScheduleInfo");
        reloadSchedule();
        closeHandle(true);
      } else {
        // 创建会议并且不是直播 校验会议试用权限
        if (syncAppointMeeting) {
          if (!state.isLive) {
            const checkTP = await checkMeetingTrialPermissions(meetingInfo);
            if (!checkTP) {
              setState({
                ...state,
                createClick: false
              });
              return message.error(
                `您暂无${meetingInfo?.meetingPlatformName}的创建权限，请开通${meetingInfo?.meetingPlatformName}创建权限后，选择该会议。您可创建其他类型视频会议日程。`
              );
            }
          }
          meetingInfo && (meetingInfo.title = scheduleData.title);
          scheduleData.description =
            scheduleData.description +
            `<p style="display:none;">${JSON.stringify(meetingInfo)}</p>`;
          focusSDK.printLog("addSchedule description", `${scheduleData.description}`);
        }
        // 代建场景
        if (state.ownerUser[0].userId !== userData.userId) {
          scheduleData.user = {
            userId: state.ownerUser[0].userId,
            teamId: state.ownerUser[0].teamId,
            realName: state.ownerUser[0].realName
          };
          scheduleData.agent = Agent.AgentAllowed;
        }
        const [data, err]: any = await addSchedule(scheduleData);
        if (err) {
          console.error(err);
          throw new Error(err);
        }

        if (isCreateSession) {
          await handleShareClick({
            ...scheduleData,
            scheduleId: data.scheduleId,
            calendarId: data.calendarId,
            description: data.description
          });
        }
        reloadSchedule();
        if (state.createFrom === CreateModalFrom.Workbench) {
          bus.emit("calendar:refresh-schedule-card");
        }
        closeHandle(true);
        message.success(t("created-successfully"));
      }
      // setState({
      //   ...state,
      //   createClick: false
      // });
    } catch (error) {
      setState({
        ...state,
        createClick: false
      });
      message.error(error.message || error);
    }
  };
  const handleShareClick = async (schedule: Schedule) => {
    const { myCalendar, t } = props;
    const { teamUserInfo } = props.userData;
    const { ddAppId, realName } = teamUserInfo;
    const sharelink = {
      ext: "",
      icon:
        "http://storage.jd.com/jd.jme.photo/message_icon_schedule2x.png?Expires=3687851871&AccessKey=93c0d2d5a6cf315c3d4c52c5f549a9a886b59f76&Signature=eADExHDPxJlqpqGBhAWpXUo6nmw%3D",
      // source: 'joyWork',
      title: t("share card title").replace("%s", realName),
      content: `${schedule.title}\n开始时间:${dayjs(schedule.beginTime).format(
        "YYYY-MM-DD HH:mm"
      )}\n结束时间:${dayjs(schedule.endTime).format("YYYY-MM-DD HH:mm")}`,
      url: DeeplinkEvent.strify({
        appId: ddAppId,
        path: DeeplinkPathEnum.Schedule_Draw,
        mparam: {
          content: schedule.description,
          scheduleId: schedule.scheduleId,
          beginTime: schedule.beginTime,
          endTime: schedule.endTime,
          isNeedCheck: true,
          calendarId: schedule.calendarId,
          color: schedule.color
        }
      }),
      category: "schedule"
    };
    const msg: ChatMessageBody = {
      type: ChatMessageType.TEMPLATE2,
      template: {
        nativeId: "share_link"
      },
      code: 0,
      data: [
        {
          sharelink: sharelink,
          type: 0
        }
      ]
    };
    const messageId = generateMessageId();
    imService.sendChatMessage(props.selectedSession?.["sessionId"] || "", messageId, msg);
    const [toUserId] = props.selectedSession?.sessionId.split(":") || [];
    if (schedule.scheduleId) {
      await shareScheduleAttachment({
        bizId: schedule.scheduleId,
        bizType: 2,
        shareRecipientDtos: [
          {
            recipientType: props.selectedSession?.isGroup ? "2" : "1",
            recipientId: toUserId,
            recipientName: props.selectedSession?.info?.name,
            teamId: teamUserInfo?.teamId,
            app: teamUserInfo?.ddAppId
          }
        ]
      });
    }
  };

  const reloadSchedule = () => {
    const { selectedTime } = props;
    // 处理日程calendar:reload没监听的情况
    if (isFocusEnv()) {
      focusSDK.sendGlobalWebviewMessage("meeting:reload-list", null);
    }
    bus.emit("calendar:reloadSchedule");
  };
  //
  const repeatHandleChange = (value: number) => {
    if (
      props.mode === ScheduleMode.Modify &&
      props.modifyScheduleContent?.smartMeetingMinutes?.length &&
      value > 0
    ) {
      return message.warning("该日程包含慧记，暂不支持修改为重复日程");
    }
    setState((state) => {
      return {
        ...state,
        repeat: value,
        repeatEndTime: value === 0 ? null : state.repeatEndTime
      };
    });
  };

  const mettingTypeChange = (value: any, option: any) => {
    if (value) {
      const meetingInfo = state.meetingInfo || {
        ...DEFAULT_MEETING_INFO,
        liveInfo: state.isLive ? DEFAULT_MEETING_INFO.liveInfo : undefined
      };
      setState({
        ...state,
        meetingInfo: {
          ...meetingInfo,
          meetingPlatform: value,
          meetingPlatformName: option["data-name"]
        },
        syncAppointMeeting: true
      });
    } else {
      setState({
        ...state,
        meetingInfo: {
          ...DEFAULT_MEETING_INFO,
          liveInfo: state.isLive ? DEFAULT_MEETING_INFO.liveInfo : undefined
        },
        syncAppointMeeting: false
      });
    }
  };

  const calendarColorHandleChange = (v: number) => {
    if (v <= scheduleTypeList.length) {
      setState({
        ...state,
        calendarColor: scheduleTypeList[scheduleTypeList.length - v].color
      });
    }
  };
  const handleAttachmentScroll = () => {
    if (state.resources.length > 0) {
      const cu = scrollRef?.current;
      if (!cu) {
        return;
      }
      const scrollHeight = cu.getScrollHeight();
      let scrollTop = cu.getScrollTop();
      const { clientHeight } = cu.getValues();
      cu.scrollToBottom({ top: scrollTop + scrollHeight - clientHeight - scrollTop });
    }
  };
  const onAttachmentRemove = (fileId: string) => {
    const resources = state.resources;
    const index = resources.findIndex((item) => item.bizId === fileId);
    if (index < -1) {
      return;
    }
    resources.splice(index, 1);
    console.log("Remove resources-->>", resources);
    setState({
      ...state,
      resources: resources
    });
  };
  const onAttachmentUploadFinish = (data: any) => {
    let newResources = Array.isArray(data)
      ? data.map((item: any) => {
          return {
            name: item.fileName,
            size: item.size,
            url: item.fileUrl,
            fileName: item.fileName,
            fileType: item.fileType,
            bizId: item.fileId,
            fileId: item.bizId || nanoid(20),
            fileUrl: item.fileUrl,
            fileSize: item.fileSize,
            permission: item.permission || null,
            bizType: item.bizType || TaskResourceBizType.FILE,
            resourceType: TaskResourcePermissionType.COMMON,
            status: item.status,
            creatorUserId: item?.creatorUserId
          };
        })
      : [
          {
            name: data.fileName,
            url: data.fileUrl,
            fileType: data.fileType,
            bizType: data.bizType || TaskResourceBizType.FILE,
            bizId: data.fileId,
            size: data.size,
            resourceType: TaskResourcePermissionType.COMMON,
            permission: data.permission || null,
            creatorUserId: data?.creatorUserId,
            fileName: data.fileName,
            fileUrl: data.fileUrl,
            fileId: data.fileId || nanoid(20),
            fileSize: data.fileSize,
            status: data.status
          }
        ];
    setState({
      ...state,
      resources: [...state.resources, ...newResources]
    });
    // let list = Object.keys(data).map((key) => data[key]);
  };
  const handleList = (data: any[]) => {
    const setData = data.map((item: any) => {
      return {
        ...item,
        isRemove: true
      };
    });

    return setData;
  };
  const handleUpdateCreator = async () => {
    const { t, userData, calendarList, myCalendar } = props;
    const { userId, teamUserInfo } = userData;
    const { ddAppId, teamId } = teamUserInfo;
    const isGroup = props.selectedSession?.["isGroup"];
    const sessionId = props.selectedSession?.["sessionId"];
    let canAgentForData: any[] = [];
    calendarList.forEach((element: any) => {
      let exist = false;
      for (let lItem of canAgentForData) {
        if (lItem.userId === element.user.userId) {
          exist = true;
        }
      }
      if (element.agent === Agent.AgentAllowed && !exist) {
        canAgentForData.push({
          ...element.user,
          id: element.user.userId,
          avatar: element.user.imageUrl,
          name: element.user.realName,
          calendarId: element.calendarId
        });
      }
    });
    let agentForData = canAgentForData;
    if (agentForData.length > 0) {
      agentForData.push({
        ...myCalendar.user,
        id: myCalendar.user.userId,
        avatar: myCalendar.user.imageUrl,
        name: myCalendar.user.realName + "(" + t("self") + ")",
        calendarId: myCalendar.calendarId
      });
      openUserSelectionModal(
        {
          title: t("select-creator"),
          tabs: ["agentFor"],
          single: true,
          recommendParam: {
            keyWords: state?.title || "",
            aiType: ["empl"]
          },
          // contactsFilterFlag: ["crossPlatform"],
          contactShowType: ContactShowType.multiTenement,
          currentUser: {
            app: ddAppId,
            pin: userId,
            teamId: teamId
          },
          businessTab: {
            tabName: "群成员",
            tabParam: {
              businessType: isGroup ? "group" : "project",
              businessId: isGroup ? (sessionId ? sessionId : "") : ""
            }
          },
          resultUsers: lodashCompact(state.ownerUser || []).map((item) => {
            let obj = {
              id: item.userId,
              name: item.realName,
              avatar: item.headImg,
              checked: true,
              userId: item.userId,
              teamId: item.teamId,
              visible: false
            };
            if (item.app) obj.id = obj.id + ":" + item.app;
            if (item.teamId) obj.id = obj.id + ":" + item.teamId;
            return obj;
          }),
          propAgentForData: agentForData
        },
        (data: any, close: any) => {
          analysisLog("xtbg_calhome_1640073907694", "23");
          // 过滤掉已选中的
          const { result } = data.data;
          if (!result.length) {
            return close();
          }
          const addArr: any[] = [];
          result.forEach((r: any) => {
            if (r.id) {
              const strs = r.id.split(":");
              if (strs.length > 1) {
                return addArr.push({
                  userId: strs[0],
                  teamId: strs[2],
                  app: strs[1],
                  ddAppId: strs[1],
                  headImg: r.avatar,
                  realName: r.name,
                  labelInfoList: r.labelInfoList
                });
              } else {
                return addArr.push({
                  ...r,
                  headImg: r.avatar,
                  app: ddAppId
                });
              }
            }
            const { origin } = r;
            if (origin.info) {
              addArr.push({
                userId: origin.info.userId,
                teamId: origin.info.teamId,
                app: origin.info.appId || origin.info.app,
                ddAppId: origin.info.appId || origin.info.app,
                headImg: origin.info.headImg,
                realName: origin.info.realName,
                labelInfoList: r.labelInfoList
              });
            } else {
              addArr.push({
                userId: origin.userId,
                teamId: origin.teamId,
                app: origin.app,
                ddAppId: origin.app,
                headImg: origin.headImg,
                realName: origin.realName,
                labelInfoList: r.labelInfoList
              });
            }
          });
          let { calendarId } = addArr[0];
          setState({ ...state, ownerUser: addArr, calendarId });
          close();
        },
        userData
      );
    } else if (agentForData.length <= 0) {
      setState({ ...state, noAPModalVisible: true });
    }
  };
  const handleAddParticipant = (data: any[], custom: any) => {
    const temp: any[] = [];
    const { participant } = state;
    data.forEach((m: any) => {
      const index = findIndexExecutorInTask(participant, m);
      if (index === -1) {
        temp.push(m);
      }
    });
    if (temp.length === 0 && state.meetingInfo?.meetingPlatform !== MeetingPlatform.HW) {
      return;
    }
    setState({ ...state, participant: [...participant, ...temp], meetingCustom: custom });
  };
  const handleDelParticipant = (members: any[]) => {
    const participant = state.participant;
    members.forEach((m) => {
      const index = findIndexExecutorInTask(participant, m);
      if (index > -1) {
        participant.splice(index, 1);
      }
    });
    // 这里需要深拷贝
    setState({ ...state, participant: [...participant] });
  };
  // 检查是否有附件正在上传
  const checkAttachmentUploading = (isCreateSession?: boolean) => {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const cancleAtt = (status: boolean) => {
      bus.off("cancle-attachment-upload", cancleAtt);
      if (status) {
        message.warning(props.t("attachment uploading"));
        return;
      } else {
        handleAddSchedule(isCreateSession);
      }
    };
    bus.on("cancle-attachment-upload", cancleAtt);
    bus.emit("close-modal-detail");
  };

  // 开始时间早于当前时间，弹出提示框
  const checkBeginTimeAddSchedule = (isCreateSession?: boolean) => {
    if (
      state.repeatEndTime &&
      dayjs(state.repeatEndTime).isBefore(dayjs(state.beginTime), "date")
    ) {
      return message.warn("重复截止日期不能早于日程开始日期");
    }
    let beginTime = state.beginTime.valueOf();
    let oldBeginTime = state.oldBeginTime.valueOf();
    let nowDate = Date.now();
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    if (beginTime !== oldBeginTime && beginTime < nowDate && !state.syncAppointMeeting) {
      Modal.confirm({
        content: "是否创建一个过去时间的日程？",
        okText: props.t("confirm"),
        cancelText: props.t("cancel"),
        onOk() {
          checkAttachmentUploading(isCreateSession);
        }
      });
    } else {
      checkAttachmentUploading(isCreateSession);
    }
  };

  const handleBusyIdleTimeChange = (add = true) => {
    const temp = add ? state.selTime.add(1, "day") : state.selTime.subtract(1, "day");
    getBusyIdleScheduleList(temp, busyIdleUsers, true);
  };

  const today = () => {
    getBusyIdleScheduleList(getTimeWithFixedMinute(dayjs()), busyIdleUsers, true);
  };

  const confirmBusyIdlePeople = () => {
    const selBusyIdleUser = busyIdleParticipants.filter((user) => user.isOwnerUser || user.checked);
    setBusyIdleUsers(selBusyIdleUser);
    setVisibleBusyIdleUsersModal(false);
  };

  const getScheduleAllUsersContent = useCallback(() => {
    const { t } = props;
    return (
      <div className="busy-idle-user-content">
        <div className="busy-idle-user-list">
          {busyIdleParticipants.length > 0 ? (
            busyIdleParticipants
              .filter((user) => {
                if (!busyIdleSearchValue) {
                  return true;
                } else {
                  if (user.realName.indexOf(busyIdleSearchValue) > -1) {
                    return true;
                  } else {
                    return false;
                  }
                }
              })
              .map((item, index: number) => {
                const { labelInfoList } = item;
                let dept = "";
                let proTitle = "";

                if (labelInfoList?.[1]) {
                  dept = labelInfoList[1].name;
                }
                if (labelInfoList?.[2]) {
                  proTitle = labelInfoList[2].name;
                }
                return (
                  <div
                    className="busy-idle-user-item"
                    key={"busyidle-" + item.userId + item.teamId + item.app}
                  >
                    <Checkbox
                      checked={item.checked}
                      disabled={item.isOwnerUser}
                      style={{
                        marginRight: 12
                      }}
                      onChange={(e) => {
                        if (
                          busyIdleParticipants.filter((p) => p.checked).length >= 20 &&
                          e.target.checked
                        ) {
                          return;
                        }
                        let idx = busyIdleParticipants.findIndex(
                          (b) =>
                            b.userId === item.userId &&
                            b.teamId === item.teamId &&
                            b.app === item.app
                        );
                        setBusyIdleParticipants([
                          ...busyIdleParticipants.slice(0, idx),
                          {
                            ...busyIdleParticipants[idx],
                            checked: e.target.checked
                          },
                          ...busyIdleParticipants.slice(idx + 1)
                        ]);
                      }}
                    />
                    <div className="user-item">
                      <Avatar
                        src={item.headImg}
                        name={item.realName}
                        className="avatar"
                      />
                      <div className="container">
                        <div className="title-content">
                          <div className="title">
                            <div className="name">{item.realName}</div>
                            {item?.labelInfoList && tagsNode(item?.labelInfoList)}
                          </div>
                          <span style={{ flex: 1 }} />
                        </div>
                        <div className="desc">
                          {dept && proTitle && (
                            <span className="desc-org">{`${dept}-${proTitle}`}</span>
                          )}
                          {!(dept && proTitle) && (
                            <span className="desc-org">{item.titleName || ""}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
          ) : (
            <div className="busy-idle-user-list-empty">
              <Empty image={noDataPictureTransparent} description={t("no data")} />
            </div>
          )}
        </div>
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busyIdleParticipants, busyIdleSearchValue]);

  useEffect(() => {
    const handelViewResize = () => {
      const calendarPageContainer: any = document.getElementById("calendar-page-container");
      setBusyIdleViewWidth(calendarPageContainer?.clientWidth || document.body.clientWidth - 65);
    };
    const throttleHandleViewResize = throttle(handelViewResize, 200);
    window.addEventListener("resize", throttleHandleViewResize);
    handelViewResize();
    return () => {
      window.removeEventListener("resize", throttleHandleViewResize);
    };
  }, []);

  useEffect(() => {
    // 添加或者删除附件后滚动定位
    handleAttachmentScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.resources]);

  useEffect(() => {
    try {
      if (!props.visible || !busyIdleTimeBlock.current) return;
      setTimeout(() => {
        if (state.isAllDay) {
          const beginTime = dayjs(state.beginTime.format("YYYY-MM-DD 00:00")).valueOf();
          const endTime = dayjs(state.endTime.format("YYYY-MM-DD 23:59")).add(1, "day").valueOf();
          calculateTimeByPosition(
            dayjs(beginTime),
            dayjs(endTime).subtract(1, "minute"),
            state.selTime,
            schedulePositionInfo.current,
            busyIdleTimeBlock.current
          );
        } else {
          calculateTimeByPosition(
            state.beginTime,
            state.endTime,
            state.selTime,
            schedulePositionInfo.current,
            busyIdleTimeBlock.current
          );
        }
      }, 0);
    } catch (error) {
      focusSDK.printLog("calculateTimeByPosition-->>", error.message?.toString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible, state.beginTime, state.endTime, state.isAllDay, state.schedulesByUserList]);

  useEffect(() => {
    if (!props.visible || !state.ownerUser.length) return;
    const ownerUser = state.ownerUser[0];
    const participant = state.participant;
    const index = findIndexExecutorInTask(participant, ownerUser);
    if (index > -1) {
      participant.splice(index, 1);
    }
    const userLists = [ownerUser, ...participant].splice(0, 20);
    setBusyIdleUsers(userLists);
    const allUsers: any[] = [ownerUser, ...participant].map((user: any) => {
      const uidx = findIndexExecutorInTask(userLists, user);
      if (uidx > -1) {
        return {
          ...user,
          isOwnerUser:
            user.userId + user.teamId + user.app ===
            ownerUser.userId + ownerUser.teamId + ownerUser.app,
          checked: true
        };
      } else {
        return {
          ...user,
          isOwnerUser:
            user.userId + user.teamId + user.app ===
            ownerUser.userId + ownerUser.teamId + ownerUser.app,
          checked: false
        };
      }
    });
    setBusyIdleParticipants(allUsers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.ownerUser, state.participant]);

  const getBusyIdleScheduleList = (selTime: Dayjs, users: any[], isChangeTime: boolean) => {
    // 每次创建人或参与人变更 都重新拉取忙闲数据
    getScheduleListByDateAndUsersAndGroupByUser({
      beginDate: selTime.startOf("day").valueOf(),
      endDate: selTime.endOf("day").valueOf(),
      userIds: users.map((item) => item.userId)
    })
      .then((res: any) => {
        if (isChangeTime) {
          handleTimeChange(selTime, true, res.schedulesByUser || [], state.isAllDay);
        } else {
          setState({
            ...state,
            schedulesByUserList: res.schedulesByUser || []
          });
        }
      })
      .catch((err) => {
        message.error(err.message?.toString() || "服务异常");
      });
  };

  const updateTimeState = (beginTime: Dayjs, endTime: Dayjs) => {
    setState({
      ...state,
      beginTime,
      endTime
    });
  };

  useEffect(() => {
    if (!props.visible || !busyIdleUsers.length) return;
    getBusyIdleScheduleList(state.selTime, busyIdleUsers, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busyIdleUsers]);

  useEffect(() => {
    const { userData, visible, t } = props;
    let info = props.modifyScheduleContent?.description || "";
    const index = info.indexOf('<p style="display:none;">');
    let descstr = index > -1 ? info.slice(0, index) : info;
    const getRemindText = (v: any) => {
      let text: any = {
        "0": t("none"),
        "-0": t("when-begin"),
        "-5": t("schedule-start-minute").replace("%s", "5"),
        "-10": t("schedule-start-minute").replace("%s", "10"),
        "-15": t("schedule-start-minute").replace("%s", "15")
      };
      text["-30"] = t("schedule-start-minute").replace("%s", "30");
      text["-45"] = t("schedule-start-minute").replace("%s", "45");
      text["-60"] = t("开始前1个小时");
      text[`-${60 * 2}`] = t("开始前2个小时");
      text[`-${60 * 24}`] = t("开始前1天");
      text[`-${60 * 24 * 2}`] = t("开始前2天");
      text[`-${60 * 24 * 7}`] = t("开始前1周");

      text[`${60 * 9}`] = "当天 9:00";
      text[`-${60 * (24 - 9)}`] = "提前1天 9:00";
      text[`-${60 * (24 * 2 - 9)}`] = "提前2天 9:00";
      text[`-${60 * (24 * 7 - 9)}`] = "提前1周 9:00";

      return text[v] || "";
    };
    if (visible) {
      // 展示
      // getTimeWithFixedMinute(props.beginTime || dayjs());
      let now = dayjs();
      // 如下操作是将传入的开始结束时间点进行转换，转化为今天的相对应 HH:mm，这里开始结束时间只关注小时分钟，不关注天
      let nowYYYYMMDD = props.beginTime
        ? props.beginTime.format("YYYY-MM-DD")
        : now.format("YYYY-MM-DD");
      let beginTimeHHmm = props.beginTime ? props.beginTime.format("HH:mm") : now.format("HH:mm");
      let endTimeHHmm = props.endTime
        ? props.endTime.format("HH:mm")
        : now.add(30, "minute").format("HH:mm");

      let endTimeYYYYMMDD = props.endTime
        ? props.endTime.format("YYYY-MM-DD")
        : now.add(30, "minute").format("YYYY-MM-DD");
      if (props.mode !== ScheduleMode.Modify && !isCopyCreate) {
        const initBeginTime =
          props.createFrom === CreateModalFrom.DragCreate
            ? props.beginTime
            : getTimeWithFixedMinute(dayjs(`${nowYYYYMMDD} ${beginTimeHHmm}`));
        const initEndTime =
          props.createFrom === CreateModalFrom.DragCreate
            ? props.endTime
            : getTimeWithFixedMinute(dayjs(`${endTimeYYYYMMDD} ${endTimeHHmm}`)); // 只关注时分，不关注是哪一天。
        const meetingobj = {
          ...DEFAULT_MEETING_INFO,
          liveInfo: props.isLive ? DEFAULT_MEETING_INFO.liveInfo : undefined
        };
        if (props.meetingPlatform) {
          meetingobj.meetingPlatform = props.meetingPlatform;
          meetingobj.meetingPlatformName =
            props.conferencePlatforms.find(
              (item: any) => item.platformType === props.meetingPlatform
            )?.platformName || "";
          meetingobj.liveInfo && (meetingobj.liveInfo.maxPeopleCount = DEFAULT_MAX_PEOPLE);
        }
        let defaultParticipant = props.defaultParticipant || [];
        setState({
          ...state,
          visible: true,
          title: props.title
            ? props.title.length > 100
              ? props.title.substr(0, 100)
              : props.title
            : "",
          resources: props.messageResource
            ? [decorateQuickCreateTaskResource(props.messageResource)]
            : [],
          beginDate: props.beginTime || dayjs(),
          endDate: props.endTime || dayjs(),
          oldBeginTime: initBeginTime,
          beginTime: initBeginTime,
          endTime: initEndTime,
          repeatEndTime: props.repeatEndTime,
          // endTimeList: getEndTimeList(props.beginTime || now),
          quickCreateFlag: props.quickCreate,
          createFrom: props.createFrom, // 创建来源
          meetingInfo: meetingobj,
          syncAppointMeeting: !!props.defaultAppointment,
          isLive: !!props.isLive,
          meetingCustom: {
            room: null,
            terminalId: []
          },
          calendarId: props.frozenCalendarId,
          calendarColor: "FF5EA7F8",
          // TODO:创建人
          ownerUser: [
            {
              userId: userData.userId,
              teamId: userData.teamUserInfo.teamId,
              app: userData.ddAppId,
              headImg: userData.teamUserInfo.headImg || "",
              realName: userData.teamUserInfo.realName || userData.account
            }
          ],
          participant: defaultParticipant,
          isCrossPlatform: props.isCrossPlatform || 0,
          // 拷贝一份作为退出确认比对用
          scheduleCopy: {
            title: props.title
              ? props.title.length > 100
                ? props.title.substr(0, 100)
                : props.title
              : "",
            resources: props.messageResource
              ? [decorateQuickCreateTaskResource(props.messageResource)]
              : [],
            beginTime: initBeginTime,
            endTime: initEndTime,
            repeatEndTime: props.repeatEndTime,
            // endTimeList: getEndTimeList(props.beginTime || now),
            meetingInfo: { ...meetingobj },
            syncAppointMeeting: !!props.defaultAppointment,
            calendarId: props.frozenCalendarId,
            isAllDay: false,
            repeat: 0,
            address: "",
            calendarColor: "FF5EA7F8",
            description: descstr,
            remark: "",
            remindList: [RemindMode.Start0, RemindMode.Start15],
            isRemind: true,
            customizeRemind: [],
            // TODO:创建人
            ownerUser: [
              {
                userId: userData.userId,
                teamId: userData.teamUserInfo.teamId,
                app: userData.ddAppId,
                headImg: userData.teamUserInfo.headImg || "",
                realName: userData.teamUserInfo.realName || userData.account
              }
            ],
            participant: defaultParticipant
          },
          selTime: initBeginTime || dayjs(),
          schedulesByUserList: []
        });
      } else {
        if (props.modifyScheduleContent) {
          let meetingobj = null;
          let remark = props.modifyScheduleContent.remark || "";
          let ddAppId = props.modifyScheduleContent.ddAppId;
          let participant =
            props.modifyScheduleContent.participant?.map((item: any) => {
              return {
                ...item.user,
                headImg: item.user?.imageUrl,
                app: item.user?.ddAppId || ddAppId
                // app: props.modifyScheduleContent.ddAppId,
              };
            }) || [];
          let ownerUser =
            [
              {
                ...props.modifyScheduleContent.user,
                headImg: props.modifyScheduleContent.user.imageUrl,
                app: ddAppId
              }
            ] || [];
          const index = info.indexOf('<p style="display:none;">');
          if (index !== -1) {
            descstr = info.slice(0, index);
            let meetingstr = info.slice(index);
            meetingstr = meetingstr
              .replace('<p style="display:none;">', "")
              .replace("</p>", "")
              .trim();
            if (meetingstr) {
              meetingstr = meetingstr.replace(/[\r\n]/g, "");
              const obj = JSON.parse(meetingstr);
              if (props.isCopyCreate) {
                meetingobj = {
                  ...obj,
                  title: "",
                  meetingId: "",
                  meetingUuid: "",
                  password: "",
                  liveInfo: undefined
                };
              } else if (obj.meetingId && obj.meetingType === 0 && obj.type === "meeting") {
                meetingobj = obj;
              }
            }
          }
          setState({
            ...state,
            visible: true,
            title: props.modifyScheduleContent.title,
            beginDate:
              props.modifyScheduleContent.scheduleBeginTime ||
              dayjs(props.modifyScheduleContent.beginTime),
            endDate:
              props.modifyScheduleContent.scheduleEndTime ||
              dayjs(props.modifyScheduleContent.endTime),
            oldBeginTime:
              props.modifyScheduleContent.scheduleBeginTime ||
              dayjs(props.modifyScheduleContent.beginTime),
            beginTime:
              props.modifyScheduleContent.scheduleBeginTime ||
              dayjs(props.modifyScheduleContent.beginTime),
            endTime:
              props.modifyScheduleContent.scheduleEndTime ||
              dayjs(dayjs(props.modifyScheduleContent.endTime)),
            repeatEndTime:
              props.modifyScheduleContent.modifyType === ModifyType.RepeatOne
                ? null
                : props.modifyScheduleContent.repeatEndTime,
            isAllDay: props.modifyScheduleContent.isAlldate,
            repeat:
              props.modifyScheduleContent.modifyType === ModifyType.RepeatOne
                ? 0
                : props.modifyScheduleContent.repeat,
            remindList: props.modifyScheduleContent.remind
              ? props.modifyScheduleContent.remind
                  .split(",")
                  .sort((a: string, b: string) => {
                    return Number(b) - Number(a);
                  })
                  .filter((item: any) => {
                    return !!getRemindText(item);
                  })
              : [RemindMode.Start0, RemindMode.Start15], // 默认15分钟
            isRemind:
              props.modifyScheduleContent.remind !== RemindMode.No ||
              props.modifyScheduleContent.customizeRemind
                ? true
                : false,
            customizeRemind: props.modifyScheduleContent.customizeRemind
              ? props.modifyScheduleContent.customizeRemind
                  .split(",")
                  .sort((a: string, b: string) => {
                    return Number(a) - Number(b);
                  })
              : [],
            address: props.modifyScheduleContent.address,
            calendarId: props.modifyScheduleContent.calendarId,
            // 编辑时初始值设置为当前的日程颜色，当为空时，会选用当前的日历颜色
            // 默认显示后端返回的值20210406
            calendarColor: props.modifyScheduleContent.color,
            // description: props.modifyScheduleContent.description,
            description: descstr,
            resources: props.modifyScheduleContent.resources,
            participant: cloneDeep(participant),
            // TODO: 这里需要返回创建人
            ownerUser: ownerUser,
            isLive: !!meetingobj?.liveInfo?.liveId,
            meetingCustom: {
              room: null,
              terminalId: []
            },
            // TODO: 暂时还不确定有没有修改视频信息的接口，如果是带视频会议的日程，只允许修改日程其它信息
            syncAppointMeeting: meetingobj ? true : false,
            meetingInfo: meetingobj,
            remark,
            isCrossPlatform: props.modifyScheduleContent.isCrossPlatform,
            selTime:
              props.modifyScheduleContent.scheduleBeginTime ||
              dayjs(props.modifyScheduleContent.beginTime),
            schedulesByUserList: [],
            // 拷贝一份作为退出确认比对用
            scheduleCopy: {
              title: props.modifyScheduleContent.title,
              beginTime:
                props.modifyScheduleContent.scheduleBeginTime ||
                dayjs(props.modifyScheduleContent.beginTime),
              endTime:
                props.modifyScheduleContent.scheduleEndTime ||
                dayjs(dayjs(props.modifyScheduleContent.endTime)),
              isAllDay: props.modifyScheduleContent.isAlldate,
              repeat: props.modifyScheduleContent.repeat,
              repeatEndTime: props.modifyScheduleContent.repeatEndTime,
              remindList: props.modifyScheduleContent.remind
                ? props.modifyScheduleContent.remind.split(",").sort((a: string, b: string) => {
                    return Number(b) - Number(a);
                  })
                : [RemindMode.Start0, RemindMode.Start15], // 默认15分钟
              isRemind:
                props.modifyScheduleContent.remind !== RemindMode.No ||
                props.modifyScheduleContent.customizeRemind
                  ? true
                  : false,
              customizeRemind: props.modifyScheduleContent.customizeRemind
                ? props.modifyScheduleContent.customizeRemind
                    .split(",")
                    .sort((a: string, b: string) => {
                      return Number(a) - Number(b);
                    })
                : [],
              address: props.modifyScheduleContent.address,
              calendarId: props.modifyScheduleContent.calendarId,
              // 编辑时初始值设置为当前的日程颜色，当为空时，会选用当前的日历颜色
              // 默认显示后端返回的值20210406
              calendarColor: props.modifyScheduleContent.color,
              // description: props.modifyScheduleContent.description,
              description: descstr,
              resources: props.modifyScheduleContent.resources,
              participant: participant,
              // TODO: 这里需要返回创建人
              ownerUser: ownerUser,
              // TODO: 暂时还不确定有没有修改视频信息的接口，如果是带视频会议的日程，只允许修改日程其它信息
              syncAppointMeeting: meetingobj ? true : false,
              meetingInfo: meetingobj,
              remark
            }
          });
        }
      }
      // 每次打开创建日程窗口时，根据条件获取权限与会议类型
      // 如果初始化时获取权限失败，则重新获取一次权限
      if (!permissions) {
        GlobalPermissionsFun({
          setPermissions,
          contextGlobalDataInitFlag: globalDataInitFlag,
          setGlobalDataInitFlag
        });
      }
      // 每次打开创建面板都重新获取可用会议类型列表信息
      props.getConferencePlatforms();
    }
    return () => {
      if (!props.visible) return;
      schedulePositionInfo.current = [];
      setBusyIdleUsers([]);
      setState({
        ...state,
        createClick: false,
        visible: false,
        title: "",
        beginDate: dayjs(),
        endDate: dayjs(),
        beginTime: dayjs(),
        endTime: dayjs().add(30, "minute"),
        repeatEndTime: null,
        isAllDay: false,
        repeat: 0,
        remind: RemindMode.Start0 + "," + RemindMode.Start15, // 默认前15分钟提醒
        address: "",
        meetingCustom: {
          room: null,
          terminalId: []
        },
        calendarId: "",
        calendarColor: "",
        description: "",
        remark: "",
        quickCreateFlag: quickCreate,
        createFrom: CreateModalFrom.Unknown, // 创建来源
        resources: [],
        remindList: [RemindMode.Start0, RemindMode.Start15],
        isRemind: true,
        customizeRemind: [],
        participant: [],
        // TODO:创建人
        syncAppointMeeting: false,
        meetingInfo: null,
        meetingInfoChanged: false,
        scheduleCopy: null,
        isCrossPlatform: 0,
        schedulesByUserList: []
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible]);

  const { mode, t } = props;
  // 日程颜色
  // 现在日历没有颜色概念，当颜色为空时，设置默认颜色
  const scheduleColor = (state.calendarColor || scheduleTypeList[2].color).toUpperCase();
  let noAgentPermissionModal = (
    <Modal
      className="noap-modal-wrapper"
      title="代理日程"
      centered
      onCancel={() => setState({ ...state, noAPModalVisible: false })}
      width={403}
      footer={null}
      visible={state.noAPModalVisible}
    >
      <p className="title">您暂无权限为他人代理日程</p>
      <p className="info">
        如您需要替他人创建日程，必须他人在个人日历的设置页添加您为日历代理人，添加成功后，可以为他们代理日程。
      </p>
    </Modal>
  );

  if (props.visible) {
    return (
      <Drawer
        destroyOnClose={true}
        afterVisibleChange={(visible) => {
          if (visible) {
            themeRef?.current?.focus();
          }
        }}
        // getContainer={
        //   document.getElementById("calendar-page-container") ||
        //   (document.querySelector(".appContent") as any)
        // }
        placement="right"
        closable={false}
        title={
          <div className="create-schedule-view-header">
            <div className="create-view-header">
              <span>
                {mode === ScheduleMode.Modify
                  ? state.isLive
                    ? t("edit-live")
                    : t("edit-schedule")
                  : state.isLive
                  ? t("create-new-live")
                  : t("create-new-schedule")}
              </span>
              <IconFont
                type="iconty_close"
                className="close-drawer app-region-none"
                onClick={() => {
                  closeHandle();
                }}
              />
            </div>
            <BusyIdleViewHeader
              t={t}
              time={state.selTime}
              today={today}
              handleBusyIdleTimeChange={handleBusyIdleTimeChange}
            >
              <IconFont
                className="filter app-region-none"
                onClick={() => {
                  setVisibleBusyIdleUsersModal(true);
                }}
                type="icona-ic_pc_im_screen"
              />
            </BusyIdleViewHeader>
          </div>
        }
        visible={true}
        width={busyIdleViewWidth}
        className="create-schedule-drawer-wrapper"
      >
        <div ref={scheduleViewDrawRef} className="create-schedule-view-body">
          <ScrollView ref={scrollRef} className="create-schedule-scroll-view">
            <div className="create-schedule-view">
              <CopyFrame>
                <div
                  className="df aic basic-line basic-line-small-space"
                  style={{ marginLeft: 10, marginRight: 10 }}
                >
                  {/* <Input
                              onChange={(e) => titleChangeHandle(e)}
                              placeholder={t('add-theme')}
                              value={state.title}
                              style={{ flex: 1 }}
                              maxLength={100}
                              className="calendar-custom-input schedule-title-input"
                          /> */}
                  <BaseTextArea
                    ref={themeRef}
                    placeholder={t("add-theme")}
                    style={{ flex: 1 }}
                    autoSize={{ minRows: 1 }}
                    value={state.title}
                    maxLength={100}
                    // showCount={true}
                    onKeyPress={() => {
                      if (state.title.length >= 100) {
                        message.destroy();
                        return message.warn(t("title limit 100"));
                      }
                    }}
                    className="calendar-custom-textarea schedule-textarea cursor-outline"
                    onChange={(e) => titleChangeHandle(e)}
                  />
                </div>
              </CopyFrame>
              <div className="df aic basic-line">
                <p className="left-indicator-wrapper">
                  <span className="required">*</span>
                  {t("creator")}
                </p>
                <div className="creator">
                  <UserListMore
                    disable={!!state.ownerUser.length}
                    list={state.ownerUser}
                    maxLength={8}
                    addMemberCb={handleUpdateCreator}
                    title={state.title}
                    label="participant"
                    notAvatar={true}
                    notTooltip={true}
                    notPersonalCalendar={true}
                    userPopover="schedule"
                  />
                  {/* TODO: 默认是自己，下个版本实现代建 */}
                  {/* TODO: 新建可选人代建，编辑状态不可修改被代建人 */}
                  {state.ownerUser.length && mode !== ScheduleMode.Modify && !state.isLive ? (
                    <div
                      className="update-creator"
                      onClick={handleUpdateCreator}
                      clstag="pageclick|keycount|xtbg_calhome_1640073907694|23"
                    >
                      <span>更改</span>&nbsp;
                    </div>
                  ) : null}
                </div>
              </div>
              {/* 参与人 */}
              <div className="df aic basic-line">
                <p className="left-indicator-wrapper">
                  {/* 注释掉参与人不能为空限制 */}
                  {/* <span className="required">*</span> */}
                  {t("participant")}
                </p>
                <div
                  className={`participant-content ${
                    state.participant.length > 0 ? "participant-content-data" : ""
                  }`}
                >
                  <UserListMore
                    platform={state.meetingInfo?.meetingPlatform}
                    list={state.participant}
                    maxLength={5}
                    handleAddTaskMembers={handleAddParticipant}
                    disable={false}
                    sessionId={props.selectedSession ? props.selectedSession.sessionId : undefined}
                    isGroup={props.selectedSession ? props.selectedSession.isGroup : undefined}
                    title={state.title}
                    notAvatar={true}
                    notTooltip={true}
                    contactShowType={ContactShowType.all}
                    notPersonalCalendar={true}
                    userPopover="schedule"
                  />
                  {state.participant.length > 0 && (
                    <UserStatusListPopover
                      popoverName="getContent"
                      list={state.participant}
                      onRemove={handleDelParticipant}
                      notPersonalCalendar={true}
                      mode={props.mode === ScheduleMode.Modify ? "edit" : "create"}
                      userPopover="schedule"
                      userPopoverText="participant"
                    >
                      <IconFont
                        type="iconlog_enter"
                        className="icon-more icon-toggle participant-icon-more"
                        style={{ color: "#8f959e" }}
                      />
                    </UserStatusListPopover>
                  )}
                </div>
              </div>
              {/* 新的日程重要程度 */}
              <div className="df aic basic-line important-level">
                <p className="left-indicator-wrapper">
                  <span className="required">*</span>
                  <label>{t("schedule type")}</label>
                </p>
                {/* <ScheduleTypeSelect
                    // 当calendarColor为空时应该选择当前选中的日历颜色
                    value={scheduleColor}
                    isMultiply={false}
                    showTooltip={true}
                    handleSelect={(c) => calendarColorHandleChange(c)}
                  /> */}
                <TypeSelect
                  priority={
                    scheduleTypeList.length -
                    scheduleTypeList.findIndex(
                      (type) => type.color?.toUpperCase() === scheduleColor
                    )
                  }
                  onRadioChange={(c) => calendarColorHandleChange(c)}
                  type="radio"
                  isCreate={true}
                />
              </div>
              {/* 时间 */}
              <div className="df aic basic-line">
                <p className="left-indicator-wrapper" style={{ letterSpacing: "14px" }}>
                  <span className="required">*</span>
                  {t("time")}
                </p>
                <div className="df" style={{ alignItems: "center" }}>
                  <div className="df calendar-date" style={{ flex: 1 }}>
                    <CalendarDatePicker
                      isAllDay={state.isAllDay}
                      time={state.beginTime || null}
                      onChange={(time: Dayjs | null) => {
                        // handleTimeChange(time, true, state.schedulesByUserList, state.isAllDay)
                        if (!time) return;
                        getBusyIdleScheduleList(time, busyIdleUsers, true);
                      }}
                      placeholder={t("set start time")}
                      isDateFormat={true}
                      isChangeHeaderVisible={true}
                    />
                  </div>

                  <span
                    className="df"
                    style={{
                      width: "13px",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#8F959E",
                      height: "1px",
                      margin: "0 4px"
                    }}
                  />
                  <div className="df calendar-date" style={{ flex: 1 }}>
                    <CalendarDatePicker
                      isAllDay={state.isAllDay}
                      time={state.endTime || null}
                      onChange={(time: Dayjs | null) =>
                        handleTimeChange(time, false, state.schedulesByUserList, state.isAllDay)
                      }
                      placeholder={t("set end time")}
                      isDateFormat={true}
                      isChangeHeaderVisible={true}
                      isInitTime={false}
                    />
                  </div>
                </div>
              </div>
              {/* 全天 */}
              <div className="df aic basic-line">
                <p className="left-indicator-wrapper" />
                <div className="df" style={{ flex: 1 }}>
                  <Checkbox
                    className="calendar-custom-radio"
                    onClick={(e: any) => {
                      let rmdList: any[] = [];
                      if (!e.target?.checked) {
                        // let beginTime = dayjs(
                        //     state.beginTime.format('YYYY-MM-DD')
                        // );
                        // let endTime = dayjs(
                        //     state.beginTime.format('YYYY-MM-DD')
                        // ).add(1, 'day');
                        // rmdList.push(`${60 * 9}`);
                        rmdList = [RemindMode.Start0, RemindMode.Start15];
                        setState({
                          ...state,
                          isAllDay: !state.isAllDay,
                          remindList: rmdList
                        });
                      } else {
                        // rmdList.push('-15');
                        rmdList.push(`${60 * 9}`);
                        setState({
                          ...state,
                          isAllDay: !state.isAllDay,
                          remindList: rmdList
                        });
                      }
                    }}
                    checked={state.isAllDay}
                  >
                    <label className="time-type" style={{ fontSize: "13px" }}>
                      全天
                    </label>
                  </Checkbox>
                </div>
              </div>
              {/* 重复 */}
              {state.meetingInfo?.meetingPlatform !== MeetingPlatform.HW && (
                <div className="df aic basic-line">
                  <p className="left-indicator-wrapper" style={{ letterSpacing: "14px" }}>
                    {t("repeat")}
                  </p>
                  <div
                    className="repeat-setting"
                    style={{
                      display: "flex",
                      flex: 1,
                      justifyContent: "space-between",
                      lineHeight: "32px"
                    }}
                  >
                    {state.isLive ? (
                      t("no-repeat")
                    ) : (
                      <RepatSelect
                        onChange={repeatHandleChange}
                        minutespan={
                          state.isAllDay
                            ? dayjs(state.endTime?.format("YYYY-MM-DD 23:59")).diff(
                                dayjs(state.beginTime?.format("YYYY-MM-DD 00:00")),
                                "minute"
                              )
                            : state.beginTime && state.endTime.diff(state.beginTime, "minute")
                        }
                        value={state.repeat}
                      />
                    )}
                    {state.repeat !== 0 && (
                      <div className="repeat-setting-endtime">
                        <CalendarDatePicker
                          isAllDay={true}
                          isRepeatPicker={true}
                          isForever={state.repeatEndTime ? false : true}
                          time={state.repeatEndTime ? dayjs(state.repeatEndTime) : null}
                          onChange={(time: Dayjs | null) => {
                            log.debug("time", time);
                            handleRepeatTimeChange(time);
                          }}
                          placeholder={t("yo valid")}
                          isDateFormat={true}
                          isChangeHeaderVisible={true}
                          isEnd={true}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
              {/* 会议类型 */}
              <div className="df aic basic-line">
                <p className="left-indicator-wrapper">{t("metting type")}</p>
                <div className="metting-type">
                  {state.isLive ? (
                    props.conferencePlatforms.find(
                      (item) => item.platformType === state.meetingInfo?.meetingPlatform
                    )?.platformName
                  ) : (
                    <Select
                      style={{ width: "100%" }}
                      defaultValue={
                        state.meetingInfo?.meetingPlatform ||
                        props.conferencePlatforms[0]?.platformType
                      }
                      placeholder={
                        config[ConfigEnum.TOP_BAR_MENU_MEETING_APPOINT] &&
                        props.conferencePlatforms.length > 0
                          ? t("meetingPassLabel")
                          : t("meetingDisable")
                      }
                      value={state.meetingInfo?.meetingPlatform || ""}
                      showArrow={true}
                      suffixIcon={
                        <IconFont
                          type="iconicon_down"
                          className="anticon-down icon-more icon-toggle"
                        />
                      }
                      onChange={mettingTypeChange}
                      className="calendar-custom-select calendar-custom-select-arrow"
                    >
                      {props.conferencePlatforms.map(
                        (platform: conferencePlatformsProp, index: number) => {
                          return (
                            <Option
                              key={index}
                              data-name={platform.platformName}
                              value={platform.platformType}
                            >
                              {platform.platformName}
                            </Option>
                          );
                        }
                      )}
                    </Select>
                  )}
                </div>
              </div>
              {/* 线上会议 */}
              {state.syncAppointMeeting && (
                <div className="df aic basic-line">
                  <p className="left-indicator-wrapper">{t("online metting pass")}</p>
                  <Input
                    maxLength={6}
                    placeholder="请设置6位数字密码"
                    onChange={handlechangeMeetingPass}
                    className={`calendar-custom-input calendar-meeting-input
                                  ${
                                    state.syncAppointMeeting
                                      ? "calendar-meeting-input-interactive"
                                      : ""
                                  }`}
                    ref={meetingPasswordRef}
                    // disabled={state.syncAppointMeeting ? false : true}
                    disabled={!state.syncAppointMeeting}
                    value={state.syncAppointMeeting ? state.meetingInfo?.password : ""}
                    allowClear
                  />
                </div>
              )}
              {state.isLive && (
                <div className="df aic basic-line">
                  <p className="left-indicator-wrapper">直播限制</p>
                  <div className="metting-type">
                    <LiveLimit
                      onChange={handleLimitChange}
                      value={state.meetingInfo?.liveInfo?.maxPeopleCount || DEFAULT_MAX_PEOPLE}
                    />
                  </div>
                </div>
              )}
              <div className="module-cross-line" />
              {/* 提醒 */}
              <div className="df aic basic-line remind-select-wrapper">
                <p className="left-indicator-wrapper" style={{ letterSpacing: "14px" }}>
                  {t("remind")}
                </p>
                <div className="remind-content">
                  <Switch checked={state.isRemind} onChange={onSwitchChange} />
                  {state.isRemind && (
                    <>
                      <div className="relative-time">
                        <Tooltip title={t("presets remind")}>
                          <span className="icon-remind">
                            <IconFont type="iconic_pc_presetreminder" />
                          </span>
                        </Tooltip>
                        <RemindSelect
                          isAllDay={state.isAllDay}
                          value={state.remindList}
                          onChange={(val: RemindMode[]) => {
                            setState({
                              ...state,
                              remindList: val
                            });
                          }}
                        />
                      </div>
                      <div className="absolute-time">
                        <Tooltip title={t("custom remind")}>
                          <span className="icon-remind">
                            <IconFont type="iconic_pc_customreminder" />
                          </span>
                        </Tooltip>
                        <div className="absolute-time-list">
                          {state.customizeRemind.map((customTime, index) => (
                            <div
                              key={"custom-remindtime-" + index}
                              className="df calendar-date absolute-time-item"
                              style={{ flex: 1 }}
                            >
                              <CalendarDatePicker
                                time={dayjs(Number(customTime))}
                                onChange={(time: Dayjs | null) =>
                                  handleCustomRemindChange(time, index)
                                }
                                isDateFormat={true}
                                isChangeHeaderVisible={true}
                              />
                              <Tooltip title={t("delete custom remind")}>
                                <span
                                  className="icon-remindtime-delete"
                                  onClick={() => deleteCustomRemind(index)}
                                >
                                  <IconFont type="iconty_close" />
                                </span>
                              </Tooltip>
                            </div>
                          ))}
                          {state.customizeRemind.length < 5 ? (
                            <span className="add-remind-btn" onClick={() => addCustomRemind()}>
                              添加自定义提醒
                            </span>
                          ) : (
                            <span className="add-remind-limit">自定义提醒已达上限</span>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              {/* 日程地点 */}
              <CopyFrame>
                <div className="df aic basic-line description-line">
                  <p
                    className="left-indicator-wrapper"
                    style={{
                      alignSelf: "flex-start",
                      marginTop: "5px",
                      letterSpacing: "14px"
                    }}
                  >
                    {t("address")}
                  </p>
                  <BaseTextArea
                    style={{ flex: 1 }}
                    autoSize={{ minRows: 1 }}
                    placeholder={t("calendar please input")}
                    value={state.address}
                    maxLength={50}
                    // showCount={true}
                    className="calendar-custom-textarea schedule-textarea cursor-outline"
                    onChange={(e) => addressChangeHandle(e)}
                    onBlur={() => {
                      let value = state.address;
                      if (value.trim() && value.trim().length > 50) {
                        value = value.slice(0, 50);
                        setState({ ...state, address: value });
                      }
                    }}
                    onKeyPress={() => {
                      if (state.address.length >= 50) {
                        message.destroy();
                        return message.warn("日程地址最多可输入50字");
                      }
                    }}
                  />
                </div>
              </CopyFrame>
              {/* 日程描述 */}
              <CopyFrame>
                <div className="df aic basic-line description-line">
                  <p
                    className="left-indicator-wrapper"
                    style={{
                      alignSelf: "flex-start",
                      marginTop: "5px",
                      letterSpacing: "14px"
                    }}
                  >
                    {t("calendar description")}
                  </p>
                  <BaseTextArea
                    style={{ flex: 1 }}
                    autoSize={{ minRows: 1 }}
                    placeholder={t("calendar please input")}
                    value={state.description}
                    maxLength={500}
                    // showCount={true}
                    className="calendar-custom-textarea schedule-textarea cursor-outline"
                    onChange={(e) => descriptionChangeHandle(e)}
                    onBlur={() => {
                      let value = state.description;
                      if (value.trim() && value.trim().length > 500) {
                        value = value.slice(0, 500);
                        setState({ ...state, description: value });
                      }
                    }}
                    onKeyPress={() => {
                      if (state.description.length >= 500) {
                        message.destroy();
                        return message.warn("日程描述最多可输入500字");
                      }
                    }}
                  />
                  {/* </div> */}
                </div>
              </CopyFrame>
              <div className="module-cross-line" />
              {/* 附件 */}
              <div className="df aic basic-line">
                <div className="left-indicator-wrapper left-indicator-toggle">
                  <AttachmentItem
                    disabled={false}
                    mode={props.mode === ScheduleMode.Modify ? "modify" : "create"}
                    uploaderProxy={true}
                    multiple={true}
                    fileList={handleList(state.resources || [])}
                    onAttachmentRemove={onAttachmentRemove}
                    onAttachmentUploadFinish={onAttachmentUploadFinish}
                    businessForm={BusinessForm.CALENDAR}
                    uploadControlName="schedule-create-upload-panel"
                  />
                </div>
              </div>
              {/* 分割线 */}
              <div className="module-cross-line" />
              {/* TODO: 我的备注 */}
              <CopyFrame>
                <div className="df aic basic-line remark-line" style={{ flexDirection: "column" }}>
                  <div className="left-indicator-wrapper left-indicator-toggle">
                    <Collapse
                      defaultActiveKey={["1"]}
                      expandIconPosition="right"
                      bordered={false}
                      expandIcon={() => (
                        <IconFont type="iconicon_down" className="icon-toggle icon-toggle-remark" />
                      )}
                      onChange={(aKey) => {
                        let svg = document.getElementsByClassName("icon-toggle-remark")[0]
                          ?.firstElementChild;
                        if (aKey.length > 0) {
                          svg?.setAttribute("style", "transform: rotate(-180deg)");
                        } else {
                          svg?.setAttribute("style", "transform: rotate(0deg)");
                        }
                      }}
                    >
                      <Collapse.Panel
                        header={
                          <>
                            {t("my remark")}
                            <label className="sub-title">{t("remark visible")}</label>
                          </>
                        }
                        key="1"
                      >
                        <BaseTextArea
                          style={{
                            flex: 1,
                            color: `${colors.black2}`,
                            marginTop: "9px"
                          }}
                          // placeholder={t('add--my-remark')}
                          autoSize={{ minRows: 1 }}
                          value={state.remark}
                          maxLength={500}
                          className="calendar-custom-textarea schedule-textarea cursor-outline"
                          onChange={(e) => remarkChangeHandle(e)}
                          onBlur={() => {
                            let value = state.remark;
                            if (value.trim() && value.trim().length > 500) {
                              value = value.slice(0, 500);
                              setState({ ...state, remark: value });
                            }
                          }}
                          onKeyPress={() => {
                            if (state.remark.length >= 500) {
                              message.destroy();
                              return message.warn("日程备注最多可输入500字");
                            }
                          }}
                        />
                      </Collapse.Panel>
                    </Collapse>
                  </div>
                </div>
              </CopyFrame>
            </div>
            <div className="footer-btn">
              <Button
                className="calendar-schedule-btn"
                size="middle"
                onClick={() => {
                  closeHandle();
                }}
              >
                {t("cancel")}
              </Button>
              <Button
                className="calendar-schedule-btn"
                size="middle"
                disabled={state.createClick}
                type="primary"
                clstag="pageclick|keycount|xtbg_calhome_1640073907694|28"
                onClick={debounce(() => {
                  checkBeginTimeAddSchedule();
                }, 500)}
              >
                {t("confirm")}
                {/* {mode === ScheduleMode.Modify ? t('save') : t('create')} */}
              </Button>
              {props.selectedSession && (
                <Button
                  className="calendar-schedule-btn"
                  size="middle"
                  type="primary"
                  disabled={state.createClick}
                  onClick={debounce(() => {
                    checkBeginTimeAddSchedule(true);
                  }, 500)}
                  clstag={`pageclick|keycount|${
                    props.isMessageModule
                      ? "Xtbg_Msg_SendToIM|MessSche"
                      : "xtbg_calhome_1640073907694|42"
                  }`}
                >
                  {t("create_and_send_to_message")}
                </Button>
              )}
            </div>
            {noAgentPermissionModal}
          </ScrollView>

          <div className="calendar-busy-idle">
            <BusyIdleView
              selTime={state.selTime}
              beginTime={state.beginTime}
              endTime={state.endTime}
              schedulesByUserList={state.schedulesByUserList}
              modifyScheduleId={
                props.mode === ScheduleMode.Modify ? props.modifyScheduleContent?.scheduleId : ""
              }
              scrollRef={scrollRef}
              busyIdleDivEl={busyIdleDivEl}
              busyIdleTimeBlock={busyIdleTimeBlock}
              schedulePositionInfo={schedulePositionInfo}
              scheduleViewDrawRef={scheduleViewDrawRef}
              updateTimeState={updateTimeState}
            />
            <Modal
              width={450}
              title="选择忙闲日历成员"
              destroyOnClose={true}
              getContainer={
                document.getElementById("calendar-page-container") ||
                (document.querySelector(".appContent") as any)
              }
              visible={visibleBusyIdleUsersModal}
              wrapClassName="busy-idle-modal-wrapper"
              onCancel={() => {
                setVisibleBusyIdleUsersModal(false);
              }}
              footer={
                <>
                  <label>
                    已选
                    <em>
                      {
                        busyIdleParticipants.filter((user) => user.isOwnerUser || user.checked)
                          .length
                      }
                    </em>
                    人，最多同时查看20人
                  </label>
                  <div>
                    <Button
                      size="middle"
                      onClick={() => {
                        setVisibleBusyIdleUsersModal(false);
                      }}
                    >
                      {t("cancel")}
                    </Button>
                    <Button
                      className="calendar-schedule-btn"
                      size="middle"
                      type="primary"
                      onClick={confirmBusyIdlePeople}
                    >
                      {t("confirm")}
                    </Button>
                  </div>
                </>
              }
            >
              <Input
                className="search-people"
                placeholder="搜索"
                onChange={(e: any) => {
                  setBusyIdleSearchValue(e.target.value);
                }}
                value={busyIdleSearchValue}
                suffix={
                  <IconFont
                    type="iconlog_del"
                    className="clear"
                    onClick={() => {
                      setBusyIdleSearchValue("");
                    }}
                  />
                }
                prefix={<IconFont type="iconjs_ic_search" className="search" />}
              />
              {getScheduleAllUsersContent()}
            </Modal>
          </div>
        </div>
      </Drawer>
    );
  } else {
    return null;
  }
}
function mapStateToProps({ user, calendar, chat }: any) {
  return {
    connectState: chat.connectState,
    userInfo: user.userInfo, // 不可用
    userData: user.userData.user,
    selectedCalendarList: calendar.selectedCalendarList,
    calendarList: calendar.calendarList,
    selectedTime: calendar.selectedTime,
    myCalendar: calendar.myCalendar,
    visible: calendar.createModalVisible,
    modifyScheduleContent: calendar.modifyScheduleContent,
    mode: calendar.createModalMode,
    quickCreate: calendar.createModalQuickCreate,
    beginTime: calendar.createModalBeginTime,
    endTime: calendar.createModalEndTime,
    title: calendar.createModalTitle,
    createFrom: calendar.createModalFrom,
    messageResource: calendar.createModalResource,
    frozenCalendarId: calendar.createModalFrozenCalendarId,
    selectedSession: calendar.createModalSelectedSession,
    defaultAppointment: calendar.createModalDefaultAppointment,
    meetingPlatform: calendar.meetingPlatform,
    isLive: calendar.isLive,
    isMessageModule: chat.isMessageModule,
    conferencePlatforms: calendar.conferencePlatforms,
    defaultParticipant: calendar.createModalDefaultParticipant,
    isCopyCreate: calendar.isCopyCreate
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    getScheduleListByTime(data: {
      user?: User;
      calendarId?: string;
      beginTime: Dayjs;
      endTime: Dayjs;
    }) {
      dispatch({ type: "calendar/getScheduleListByTime", payload: data });
    },
    setSelectedCalendarList(data: any) {
      dispatch({ type: "calendar/setSelectedCalendarList", payload: data });
    },
    openCreateModal(data: any) {
      dispatch({ type: "calendar/openCreateModal", payload: data });
    },
    getCalendarList(data: any) {
      dispatch({ type: "calendar/getCalendarList", payload: data });
    },
    changeCreateModalVisible(visible: boolean) {
      dispatch({
        type: "calendar/changeCreateModalVisible",
        payload: { visible: visible }
      });
    },
    getConferencePlatforms() {
      dispatch({ type: "calendar/getConferencePlatforms" });
    }
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation("calendar")(CreateSchedule));
